/* global debounce */

// Initialise and observe animate on scroll
if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const initAnimateOnScroll = () => {
      // Select on :not(.cc-animate-in) rather than :not(.cc-animate-init). Apps that re-render
      // the product grid clone markup that already carries cc-animate-init, which the old
      // selector skipped. Those clones were never observed, never received cc-animate-in, and
      // stayed at opacity 0 while still occupying space and remaining clickable.
      const animatableElems = document.querySelectorAll('[data-cc-animate]:not(.cc-animate-in)');
      if (animatableElems.length > 0) {
        const intersectionObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            // In view and hasn't been animated yet
            if (entry.isIntersecting && !entry.target.classList.contains('cc-animate-in')) {
              entry.target.classList.add('cc-animate-in');
              observer.unobserve(entry.target);
            }
          });
        });

        // Initialise and observe each animatable element
        animatableElems.forEach((elem) => {
          // Set the animation delay
          if (elem.dataset.ccAnimateDelay) {
            elem.style.animationDelay = elem.dataset.ccAnimateDelay;
          }

          // Set the animation duration
          if (elem.dataset.ccAnimateDuration) {
            elem.style.animationDuration = elem.dataset.ccAnimateDuration;
          }

          // Init the animation
          if (elem.dataset.ccAnimate) {
            elem.classList.add(elem.dataset.ccAnimate);
          }

          elem.classList.add('cc-animate-init');

          // Watch for elem
          intersectionObserver.observe(elem);
        });
      }
    };

    // Animationerna döljer bara element från 768 px (snippets/animate-on-scroll-styles.liquid).
    // --aos-min-width är inte satt i temat, och med 0 som reserv körde
    // observatörerna även på mobil utan att göra någon nytta.
    const aosMinWidth = getComputedStyle(document.documentElement)
      .getPropertyValue('--aos-min-width').trim() || '768';
    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);
    if (mq.matches) {
      initAnimateOnScroll();

      // Check for more animatable elements when the DOM mutates.
      // Registered immediately rather than on DOMContentLoaded: apps that re-render the product
      // grid can finish before that event fires, and the mutation would then go unobserved,
      // leaving every cloned card stuck at opacity 0 while still occupying space.
      const observeMutations = () => {
        const observer = new MutationObserver(debounce(initAnimateOnScroll, 250));
        observer.observe(document.documentElement, {
          subtree: true,
          childList: true
        });
      };
      observeMutations();

      // Final safety net: anything still unrevealed once everything has loaded is shown,
      // so a failed observer can never hide products from customers.
      window.addEventListener('load', () => {
        setTimeout(() => {
          document
            .querySelectorAll('[data-cc-animate].cc-animate-init:not(.cc-animate-in)')
            .forEach((el) => el.classList.add('cc-animate-in'));
        }, 1200);
      });
    } else {
      document.body.classList.remove('cc-animate-enabled');

      try {
        mq.addEventListener('change', (event) => {
          if (event.matches) {
            document.body.classList.add('cc-animate-enabled');
            setTimeout(initAnimateOnScroll, 100);
          }
        });
      } catch (e) {
        // Legacy browsers (Safari < 14), rely on the animations being shown by the line above the
        // try
      }
    }
  } else {
    // Reveal all the animations
    document.body.classList.remove('cc-animate-enabled');
  }
}
